import { LucideIcon } from 'lucide-react';
import { STATUS_TONE_COLORS, StatusTone } from '@/components/ui/statusTone.ts';
import { EnumValueConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';

/**
 * Wartość, która jest kategorią, a nie stanem: kanał wiadomości, rola, rodzaj
 * zgody. Kropka mówi „coś się z tym dzieje" — przy „E-mail" byłaby szumem, więc
 * takie wartości zostają samym napisem.
 */
export const plainEnumConfig = (
  label: string,
  icon?: LucideIcon,
): EnumValueConfig => ({
  label,
  color: null,
  textColor: null,
  ...(icon && { icon, displayMode: 'text+icon' as const }),
});

/**
 * Wpis konfiguracji tabeli zbudowany z tonu statusu — zamiast heksów
 * przepisywanych przy każdej wartości enuma.
 *
 * Status w komórce to kropka z etykietą, więc `color` niesie barwę kropki,
 * a `textColor` zostaje pusty poza stanami wymagającymi reakcji — spokojne
 * statusy mają iść zwykłym tekstem wiersza. Ikona bierze ciemniejsze `text`:
 * odcień kropki jest dobrany pod kółko 8 px i na ikonie ginie.
 */
export const toneEnumConfig = (
  label: string,
  tone: StatusTone,
  icon?: LucideIcon,
): EnumValueConfig => {
  const { text, dot, attention } = STATUS_TONE_COLORS[tone];

  return {
    label,
    color: dot,
    textColor: attention ? text : null,
    ...(icon && { icon, iconColor: text, displayMode: 'text+icon' as const }),
  };
};
